export default {
  namespaced: true,
  state: {
    customers: [],
  },

  mutations: {
    SET_CUSTOMERS(state, customers) {
      if (customers) {
        state.customers = customers.map((customer) => {
          const { id, name: label } = customer;

          return { id, label };
        });
      }
    },
  },
};
